import { createAction } from "@reduxjs/toolkit";
import { IBooking } from "../../types/salesOrder.types";

enum BookingActionTypes {
    BOOKING_RECEIVED = "[Booking] RECEIVED",
}

export const bookingReceivedCreator = createAction<IBooking>(BookingActionTypes.BOOKING_RECEIVED);
